import dayjs from "dayjs"
import { BillGet } from "../../../data/Types"
import { ReactComponent as EYE } from "../../../assets/EyeICON.svg"
import { returnThousanderBreakInNumber } from "../../../services/functions"
import "../../../style/scroll.css"

type BillRowType = {
    item: BillGet
    navigate: () => void
}

export function BillRow(props: BillRowType) {
    return (
        <div className="w-full flex flex-row items-center gap-4 p-2 hide-horizontal-scrollbar">
            <p className="text-sm h-fit">{props.item.nr}</p>
            <p className="text-sm text-gray-400 h-fit">Erstellt am:</p>
            <p className="text-sm h-fit">{dayjs(props.item.date).format("DD.MM.YYYY")}</p>
            <p className="text-sm text-gray-400 h-fit">Netto:</p>
            <p className="text-sm h-fit">{returnThousanderBreakInNumber(props.item.totalNetto)} €</p>
            <div className="grow flex justify-end z-10 pr-4">
                <EYE onClick={props.navigate} className="w-9 h-9 cursor-pointer hover:bg-gray-200 p-2 rounded-full" />
            </div>
        </div>
    )
}
